<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4><ion-icon name="people-outline"></ion-icon> Startup List</h4>
      </div>
    </div>
    <div *ngIf="noData == false">
      <div class="table-responsives">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
          ></tr>
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>No</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="incubatorName">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.incubatorName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="startupName">
            <th mat-header-cell *matHeaderCellDef>Startup Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.startupName != null ? element?.startupName : "-" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="incubatorEmail">
            <th mat-header-cell *matHeaderCellDef>Startup Email Id</th>
            <td mat-cell *matCellDef="let element">
              {{ element.incubatorEmail }}
            </td>
          </ng-container>
          <ng-container matColumnDef="incubatorPhone">
            <th mat-header-cell *matHeaderCellDef>Startup Phone</th>
            <td mat-cell *matCellDef="let element">
              {{ element.incubatorPhone }}
            </td>
          </ng-container>
        </table>
      </div>
      <mat-paginator
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 15, 20]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>Coming soon</h6>
    </div>
  </div>
</section>
